export enum BUSINESS_TYPES {
  ACCOMMODATION = "accommodation",
  ACTIVITY = "activity",
  EAT_DRINK = "eat_drink",
}
